// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"582":"e72854b9","4189":"e72854b9","7092":"e72854b9","7995":"e72854b9"}[chunkId] + ".chunk.css";
};